import { useSyncExternalStore } from 'react';

// 断点（设计稿 23a–c）：≥1440 完整；1280–1439 收起右侧属性栏；1024–1279 侧栏变图标栏；<1024 手机布局

export type Layout = 'full' | 'noPanel' | 'rail' | 'mobile';

function compute(): Layout {
  const w = window.innerWidth;
  if (w >= 1440) return 'full';
  if (w >= 1280) return 'noPanel';
  if (w >= 1024) return 'rail';
  return 'mobile';
}

let current = compute();
const listeners = new Set<() => void>();
window.addEventListener('resize', () => {
  const next = compute();
  if (next !== current) {
    current = next;
    listeners.forEach((l) => l());
  }
});

export function useLayout(): Layout {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => current,
  );
}

export const isMobileLayout = (l: Layout) => l === 'mobile';
